import { render } from "./LicenceSelection.vue?vue&type=template&id=3b30a28c&scoped=true"
import script from "./LicenceSelection.vue?vue&type=script&lang=js"
export * from "./LicenceSelection.vue?vue&type=script&lang=js"

import "./LicenceSelection.vue?vue&type=style&index=0&id=3b30a28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b30a28c"]])

export default __exports__